module.exports = __webpack_public_path__ + "static/media/MK 7  tmp.67635715.mp3";